import { type MaterialOption, type MaterialTargetPart } from './materialOptions'

/**
 * api_proto.v1.Material の構造（gen_proto は company / customer 別ファイルに生成されるため
 * structural typing で両方を受け付ける）.
 */
export interface ProtoMaterial {
  id: bigint
  targetPart: string
  manufacturerName: string
  brandName: string
  productCode: string
  colorName: string
  thumbnailUrl: string
  displayOrder: number
}

/**
 * proto Material を MaterialPalette の MaterialOption に変換する.
 * 1st リリースでサポート外の部位 (`wall`/`roof` 以外) は `null` を返してフィルタ可能にする.
 */
export const protoMaterialToOption = (m: ProtoMaterial): MaterialOption | null => {
  if (m.targetPart !== 'wall' && m.targetPart !== 'roof') {
    return null
  }
  return {
    id: m.id,
    targetPart: m.targetPart as MaterialTargetPart,
    manufacturer: m.manufacturerName,
    brand: m.brandName,
    productCode: m.productCode,
    colorName: m.colorName,
    thumbnailUrl: m.thumbnailUrl,
    displayOrder: m.displayOrder,
  }
}

/**
 * proto Material 配列を MaterialOption 配列に変換する.
 * サポート外部位は除外する.
 */
export const protoMaterialsToOptions = (materials: ProtoMaterial[]): MaterialOption[] => {
  const result: MaterialOption[] = []
  for (const m of materials) {
    const option = protoMaterialToOption(m)
    if (option) result.push(option)
  }
  return result
}
